export class SeikyuInfo {
    azukariZandaka = "";
    mishukinTotal = "";
    seikyuMeisaiList = [];
}
